import { useState } from 'react';
import type { User } from '../api/types';

const SWATCHES = ['#3269d6', '#7a55c5', '#ce5c7b', '#198b70', '#bd6a2b', '#51627f'];

function initials(label: string): string {
  return label
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');
}

export function Avatar({
  user,
  label,
  size = 'medium',
}: {
  user?: User | null;
  label?: string;
  size?: 'small' | 'medium' | 'large';
}) {
  const text = user?.initial || label || '?';
  const color = SWATCHES[(user?.id ?? text.length) % SWATCHES.length];
  const [failedUrl, setFailedUrl] = useState<string | null>(null);

  return user?.avatar && failedUrl !== user.avatar ? (
    <img alt="" className={`avatar avatar--${size}`} onError={() => setFailedUrl(user.avatar)} src={user.avatar} />
  ) : (
    <span className={`avatar avatar--${size}`} style={{ backgroundColor: color }} aria-hidden="true">
      {initials(text)}
    </span>
  );
}
